import { CouponsPage } from './pages/CouponsPage'
import { AboutPage } from './pages/AboutPage'
import { PartnershipPage } from './pages/PartnershipPage'
import { MarketingPage } from './pages/MarketingPage'
import { WebsiteMarketingPage } from './pages/WebsiteMarketingPage'
import { FreeWebsitePage } from './pages/FreeWebsitePage'
import { FreeWebsiteSuccessPage } from './pages/FreeWebsiteSuccessPage'
import { OfferAnalytics } from './components/OfferAnalytics'
import { Navigate, Route, Routes } from 'react-router'
import { SiteLayout } from './components/layout/SiteLayout'
import { ContactPage } from './pages/ContactPage'
import { HomePage } from './pages/HomePage'
import { LegalPage } from './pages/LegalPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ServiceCategoryPage } from './pages/ServiceCategoryPage'
import { ServicePage } from './pages/ServicePage'
import { StaticPage } from './pages/StaticPage'
import { StoreServicesPage } from './pages/StoreServicesPage'
import { TrackingPage } from './pages/TrackingPage'

export default function App() {
  return (
    <><OfferAnalytics /><Routes>
      <Route element={<SiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="coupons" element={<CouponsPage />} />
        <Route path="about-us" element={<AboutPage />} />
        <Route path="partners/arina-technologies" element={<PartnershipPage />} />
        <Route path="digital-marketing" element={<WebsiteMarketingPage />} />
        <Route path="digital-marketing/packages" element={<WebsiteMarketingPage packages />} />
        <Route path="free-website" element={<FreeWebsitePage />} />
        <Route path="free-website/success" element={<FreeWebsiteSuccessPage />} />
        <Route path="digital-marketing/custom" element={<MarketingPage view="custom" />} />
        <Route path="digital-marketing/:serviceSlug" element={<MarketingPage view="detail" />} />
        <Route path="services/:categorySlug" element={<ServiceCategoryPage />} />
        <Route path="services/:categorySlug/:serviceSlug" element={<ServicePage />} />
        <Route path="Pack-Ship/Shipping/:serviceSlug" element={<ServicePage />} />
        <Route path="Pack-Ship/Packing/:serviceSlug" element={<ServicePage />} />
        <Route path="Home-Business/:serviceSlug" element={<ServicePage />} />
        <Route path="Copy-Print/:serviceSlug" element={<ServicePage />} />
        <Route path="Shipping/:serviceSlug" element={<ServicePage />} />
        <Route path="ipostal1" element={<ServicePage />} />
        <Route path="Store-Services" element={<StoreServicesPage />} />
        <Route path="Tracking" element={<TrackingPage />} />
        <Route path="contact-us" element={<ContactPage />} />
        <Route path="contact" element={<Navigate replace to="/contact-us" />} />
        <Route path="Privacy-Policy" element={<LegalPage pageId="privacy-policy" />} />
        <Route path="Privacy" element={<Navigate replace to="/Privacy-Policy" />} />
        <Route path="Terms" element={<LegalPage pageId="terms" />} />
        <Route path=":pageSlug" element={<StaticPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes></>
  )
}
